/**
 * @generated SignedSource<<cb7d78e9536868dbf7faca3a89f6f408>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SingleSelectFieldConfigFragment$data = {
  readonly id: string;
  readonly name: string;
  readonly options: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"SingleSelectFieldOptionFragment">;
  }>;
  readonly " $fragmentType": "SingleSelectFieldConfigFragment";
};
export type SingleSelectFieldConfigFragment$key = {
  readonly " $data"?: SingleSelectFieldConfigFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SingleSelectFieldConfigFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SingleSelectFieldConfigFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectV2SingleSelectFieldOption",
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "SingleSelectFieldOptionFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "optionId",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "nameHTML",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "color",
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectV2SingleSelectField",
  "abstractKey": null
};
})();

(node as any).hash = "2555f9379be97f63d413625ae01c4260";

export default node;
